export default {
  colorScheme: {
    theme: 'purple',
    color: null
  },
  showAnnouns: false,
  showNotifs: false,
  showRems: false,
  clientFeatures: {},
  providerFeatures: {},
  document_types: [],
};
